import React from 'react';

const ManageItems = () => {
  return (
    <div>
      <h1>This is Manage Items page</h1>
    </div>
  );
};

export default ManageItems;